import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';
import { FileInfo } from '../../models';
import { Resource, CriticalError } from 'digital-core';

@Component({
  selector: 'image-file-uploader',
  templateUrl: './image-file-uploader.component.html',
  styleUrls: ['./image-file-uploader.component.css']
})
export class ImageFileUploaderComponent implements OnInit {

  @Input()
  public resourceData: Resource;

  @Output()
  addFile = new EventEmitter<FileInfo>();

  @Output()
  removeFile = new EventEmitter<string>();

  @ViewChild('file') file;

  displayCamara: boolean;
  isInvalid: boolean;
  isControlValid = true;
  isVisible: boolean;
  fieldType: any;
  getFieldName: any;
  control = new UntypedFormControl('', []);
  files: FileInfo[] = [];
  mode: "Determinante";
  bufferValue = 0;
  maxFilesLimit = 5;
  scanText: string;
  scanSubText: string;
  restrictedExtensions: String[] = [];
  errorMessage: string;
  constructor(public imageCompress: NgxImageCompressService) { }

  ngOnInit() {
    if (!this.resourceData) {
      this.isInvalid = true;
      this.isVisible = false;
      throw new CriticalError(`The resource data can't be empty`);
    } else {
      this.isVisible = !this.resourceData?.Hidden;
      this.isInvalid = false;

      let array = this.resourceData?.DefaultText.split("<br>");
      this.scanText = array[0].trim();
      this.scanSubText = array[1].trim();
      if (!!this.resourceData.InternalCode) {
        this.restrictedExtensions = this.resourceData.InternalCode.split(',');
      }
      if (!this.isInvalid && this.resourceData?.IsRequired) {
        this.control.setValidators([Validators.required]);
        this.control.updateValueAndValidity();
      }
    }
  }

  setControlAsTouched() {
    this.control.markAsTouched();
    if (this.resourceData?.IsRequired && this.control.invalid) {
      this.isControlValid = false;
    }
  }

  openCamera() {
    if (this.files.length < this.maxFilesLimit) {
      this.file.nativeElement.click();
      this.setControlAsTouched();
    }
  }

  isInvlid() {
    if (this.resourceData && this.resourceData?.IsRequired && !this.isControlValid) {
      return true;
    }
    return false;
  }

  evaluateStatus() {
    let scope = this;
    let str = ""
    scope.files.forEach(element => {
      if (str === "") {
        str = element.Name
      } else {
        str += ',' + element.Name;
      }
    });
    scope.control.setValue(str);
    if (scope.resourceData?.IsRequired && scope.files.length > 0) {
      scope.isControlValid = true;
    } else if (!scope.resourceData?.IsRequired) {
      scope.isControlValid = true;
    } else {
      scope.isControlValid = false;
    }
  }

  change(event: any) {
    this.errorMessage = "";
    for (let i = 0; i < event.target.files.length; i++) {
      // Initialize an instance of the `FileReader`
      const reader = new FileReader();
      const scope = this;
      let fileName = "";
      let fileType: string;
      fileType = event.target.files[i]['type'];
      const isExtensionsNotAllowed = this.restrictedExtensions.some(x => fileType.toLocaleLowerCase().includes(x.toLocaleLowerCase()));
      if (isExtensionsNotAllowed) {
        this.returnErrorMessage();
        return false;
      }
      if (event.target.files[i].name.length > 20) {
        fileName = event.target.files[i].name.substr(0, 16) + '...' + event.target.files[i].name.substr(event.target.files[i].name.length - 4, 4);
      } else {
        fileName = event.target.files[i].name;
      }

      reader.onprogress = function (evt) {
        // evt is an ProgressEvent.
        if (evt.lengthComputable) {
          scope.bufferValue = Math.round((evt.loaded / evt.total) * 100);
        }
      };

      reader.onabort = function (e) {
        scope.returnErrorMessage();
      };

      reader.onloadend = async function (e) {
        if ((e.target as FileReader).readyState === FileReader.DONE) {
          let file = new FileInfo(fileName, this.result.toString());
          let checkFileTypeasImage = scope.checkFileType(fileType);
          if (checkFileTypeasImage) {
            const compressedFile = await scope.CompressImageFile(file, file.Name);
            scope.files.push(compressedFile);
            scope.addFile.emit(compressedFile);
          } else {
            scope.files.push(file);
            scope.addFile.emit(file);
          }
          scope.evaluateStatus();
          scope.bufferValue = 0;
        } else {
          scope.returnErrorMessage();
        }
      }

      reader.onloadstart = function (e) {
        scope.bufferValue = 5;
      };
      reader.readAsDataURL(event.target.files[i]);
    };
    this.displayCamara = false;
  }

  checkFileType(fileType: string): boolean {
    const validImageTypes = ['image/jpeg', 'image/png'];
    let imageFileCheck = validImageTypes.includes(fileType) ? true : false;
    return imageFileCheck;
  }

  returnErrorMessage(): void {
    if (!!this.resourceData?.ValidationMessage) {
      this.errorMessage = this.resourceData?.ValidationMessage;
    } else {
      this.errorMessage = "Le téléchargement du fichier a échoué.";
    }
  }

  CompressImageFile(image: any, fileName: any): any {
    const orientation = -1;
    const imageFile = this.imageCompress.compressFile(image.fileByteArray, orientation, 50, 50).then(result => {
      return new FileInfo(fileName, result);
    });
    return imageFile;
  }

  deleteFileItem(fileName: string) {
    this.files = this.files.filter(obj => obj.Name !== fileName);
    this.removeFile.emit(fileName);
    this.file.nativeElement.value = null;
    this.evaluateStatus();
  }

  reset() {
    this.files = [];
    this.file.nativeElement.value = null;
    this.evaluateStatus();
  }
}
